// @ts-strict-ignore
import * as React from 'react';
import { dayjs } from '@/extendedDayjs';
import { calculateSoakTimeRemaining, calculateElapsedSoakTime } from '../timeHelpers';
import Text from 'antd/lib/typography/Text';
import { Duration } from 'dayjs/plugin/duration';

export enum CountStyle {
    CountUp,
    CountDown,
}

interface LiveDurationComponentProps {
    startingAtDate: Date;
    thresholdDurationInSeconds?: number;
    countStyle: CountStyle;
    countColor: string;
}

const timeStringFromDuration: (duration: Duration) => string = (duration) => {
    const totalHours = Math.floor(duration.asHours());
    const durationString = `${totalHours}h ${duration.minutes()}m ${duration.seconds()}s`;

    return durationString;
};

const getUpdatedTextAndIsActive: (
    countStyle: CountStyle,
    startingAtDate: Date,
    now: dayjs.Dayjs,
    thresholdDurationInSeconds?: number,
) => [string, boolean] = (countStyle, startingAtDate, now, thresholdDurationInSeconds) => {
    const duration =
        countStyle == CountStyle.CountDown ?
            calculateSoakTimeRemaining(thresholdDurationInSeconds, startingAtDate, now)
        :   calculateElapsedSoakTime(startingAtDate, now);

    const updatedIsActive = duration.asSeconds() != 0;
    const updatedDurationText = timeStringFromDuration(duration);
    const updatedText = updatedIsActive ? updatedDurationText : 'Soak completed.';

    return [updatedText, updatedIsActive];
};

const LiveDurationComponent = (props: LiveDurationComponentProps) => {
    const [initialText, initialIsActive] = getUpdatedTextAndIsActive(
        props.countStyle,
        props.startingAtDate,
        dayjs(),
        props.thresholdDurationInSeconds,
    );

    const [durationText, setDurationText] = React.useState(initialText);
    const [isActive, setIsActive] = React.useState(initialIsActive);

    const updateDurationText = (countStyle, startingAtDate, thresholdDurationInSeconds) => {
        const [updatedText, updatedIsActive] = getUpdatedTextAndIsActive(
            countStyle,
            startingAtDate,
            dayjs(),
            thresholdDurationInSeconds,
        );

        setIsActive(updatedIsActive);
        setDurationText(updatedText);
    };

    React.useEffect(() => {
        let intervalId = null;

        if (isActive) {
            intervalId = setInterval(() => {
                updateDurationText(props.countStyle, props.startingAtDate, props.thresholdDurationInSeconds);
            }, 1000);
        } else {
            clearInterval(intervalId);
        }

        return () => clearInterval(intervalId);
    }, [isActive, props.countStyle, props.thresholdDurationInSeconds, props.startingAtDate]);

    return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
            {isActive && (
                <Text type="secondary" style={{ textAlign: 'center', fontWeight: 600 }}>
                    Elapsed soak time
                </Text>
            )}
            <Text style={{ fontSize: 30, color: props.countColor, textAlign: 'center' }}>{durationText}</Text>
        </div>
    );
};

export default LiveDurationComponent;
